<template>
  <div class="container">
    <head-nav-bar @click-left="onClickLeft" title="就诊卡管理" :fixed="true" />
    <div class="list mt-header-nav">
      <DataList ref="dataList" api="Contact_List" :onLoadCallBack="onLoad">
        <template v-slot:item="item">
          <van-card @click="toInfo(item.obj)">
            <div slot="title" style="font-weight: bold; font-size: 0.4rem">
              {{ item.obj.cardholderName }}
            </div>
            <div slot="desc" class="text-less">
              <span>{{ item.obj.cardholderSexName }}/{{ item.obj.age }}岁</span>
              <span style="margin-left: 1rem"
                >就诊卡号：{{ item.obj.cardNo }}</span
              >
            </div>
            <div slot="footer">
              <div class="flex">
                <div class="flex-item">
                  <van-checkbox v-model="item.obj.isDefault"
                    >当前就诊人</van-checkbox
                  >
                </div>
                <div class="flex-item" style="flex: 2">
                  <van-button
                    v-if="!item.obj.qrCodeText"
                    icon="sign"
                    @click.stop="onRegisterHealthCard(item.obj)"
                    size="mini"
                    >绑定电子健康卡</van-button
                  >
                  <van-button
                    icon="edit"
                    @click.stop="onEdit(item.obj)"
                    size="mini"
                    >修改</van-button
                  >
                  <van-button
                    icon="cross"
                    size="mini"
                    @click.stop="onDel(item.obj)"
                    >解绑</van-button
                  >
                </div>
              </div>
            </div>
          </van-card>
        </template>
      </DataList>

      <div class="footer-actions">
        <van-button type="info" size="large" @click="toAddCard"
          >+ 添加就诊人</van-button
        >
      </div>
      <van-dialog
        v-model="showSelectAddType"
        :showConfirmButton="false"
        :showCancelButton="true"
        title="请选择添加方式"
      >
        <div class="type-list">
          <div class="type-item" @click="onAddTypeClick(1)">
            按姓名+身份证号绑卡
          </div>
          <div class="type-item" @click="onAddTypeClick(2)">
            按姓名+就诊卡号绑卡
          </div>
        </div>
      </van-dialog>
    </div>
  </div>
</template>

<script>
import { Tag, Button, Icon, Card, Checkbox, Dialog, Toast } from "vant"
import DataList from "@/components/DataList"
import { cache } from "@/utils/common"

export default {
  name: "DoctorList",
  components: {
    DataList,
    [Tag.name]: Tag,
    [Button.name]: Button,
    [Icon.name]: Icon,
    [Card.name]: Card,
    [Checkbox.name]: Checkbox,
    [Dialog.Component.name]: Dialog.Component,
  },
  data() {
    return {
      currentContact: {},
      clickFlag: false,
      showSelectAddType: false,
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.currentContact = cache.get("currentContact")
    },
    onLoad(res) {
      const data = res.data.datas
      data.map((item) => {
        if (item.isDefault) {
          cache.set("currentContact", item)
        }
      })
      // if (this.currentContact && this.currentContact.id) {
      //   const json = data.map((item) => {
      //     if (item.id === this.currentContact.id) {
      //       item.checked = true
      //     } else {
      //       item.checked = false
      //     }
      //     return item
      //   })
      //   return json
      // } else if (data.length) {
      //   cache.set("currentContact", data[0])
      // }
    },
    toInfo(item) {
      this.$router.push({
        name: "userContactInfo",
        query: {
          Id: item.id,
        },
      })
    },
    onClickLeft() {
      this.$router.push({ name: "user" })
    },
    // onAdd() {
    //   this.$router.push({ name: "userContactEdit" });
    // },
    onEdit(item) {
      this.$router.push({
        name: "userContactEdit",
        replace: true,
        query: {
          id: item.id,
        },
      })
    },
    onDel(item) {
      Dialog.confirm({
        message: "确认删除就诊人吗？",
      })
        .then(() => {
          this.$post("Contact_Del", { Id: item.id }).then(() => {
            //删除当前就诊人，清除缓存
            if (item.checked) {
              cache.remove("currentContact")
            }
            Toast.success("删除成功！")
            this.$refs.dataList.reload()
          })
        })
        .catch(() => {
          // on cancel
        })
    },
    onRegisterHealthCard(item) {
      if (this.clickFlag == true) return
      this.clickFlag = true
      let json = {
        DiagnosisCardNo: item.cardNo,
        PatientName: item.cardholderName,
        MobilePhone: item.cardholderContactPhone,
        SexId: item.cardholderSex,
        Birthday: item.cardholderBirthDate,
        IdentityDocTypeDesc: item.identityDocTypeDesc,
        IdentityNo: item.identityDocNo,
        ContactAddress: item.cardholderContactAddress,
      }
      this.$post("Contact_RegisterHealthCard", json).then((res) => {
        this.clickFlag = false
        if (res.data.result) {
          Toast.success(res.data.message)
        } else {
          Toast.fail(res.data.message)
        }
      })
    },
    toAddCard() {
      this.showSelectAddType = true
    },
    onAddTypeClick(type) {
      this.$router.push({
        name: "userContactEdit",
        query: {
          type,
        },
      })
    },
  },
}
</script>

<style lang="less" scoped>
.list-item {
  .value {
    line-height: 2rem;
    color: #333;
    font-size: 0.5rem;
  }
  .van-card__content {
    min-height: 1.6rem;
  }
}
.type-list {
  font-size: 14px;
  padding: 20px;
  .type-item {
    padding: 20px;
    border: 1px solid #ddd;
    text-align: center;
    margin-bottom: 10px;
  }
}
</style>
